export const WriteRight = "WEB_MODULE_SETTINGS_DAY_NIGHT_WRITE";
export const Rights = [
    WriteRight
]
